import store from '@/store'
import { debounce } from 'lodash' // 假设项目中已经引入了 lodash

const { body } = document
const WIDTH = 992 // refer to Bootstrap's responsive design

export default {
  watch: {
    $route(route) {
      if (this.device === 'mobile' && this.sidebar.opened) {
        store.dispatch('app/closeSideBar', { withoutAnimation: false })
      }
    }
  },
  beforeMount() {
    // 使用防抖包装 resize 处理函数
    this.debouncedResizeHandler = debounce(this.$_resizeHandler, 100)
    window.addEventListener('resize', this.debouncedResizeHandler)
  },
  beforeDestroy() {
    // 移除防抖处理的事件监听
    window.removeEventListener('resize', this.debouncedResizeHandler)
    this.debouncedResizeHandler.cancel() // 取消所有待执行的防抖函数
  },
  mounted() {
    const isMobile = this.$_isMobile()
    if (isMobile) {
      store.dispatch('app/toggleDevice', 'mobile')
      store.dispatch('app/closeSideBar', { withoutAnimation: true })
    }
  },
  methods: {
    $_isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        store.dispatch('app/toggleDevice', isMobile ? 'mobile' : 'desktop')

        if (isMobile) {
          store.dispatch('app/closeSideBar', { withoutAnimation: true })
        }
      }
    }
  }
}
